/**
 * Centralized icon options for all category types in KaizenOS
 * Each icon has bilingual support (ES/EN)
 */

// ==========================================
// MEJORA DIARIA (Daily Improvement) ICONS
// ==========================================
export const MEJORA_ICON_OPTIONS = [
  // Original icons (mantener compatibilidad)
  { id: 'Dumbbell', name_es: 'Ejercicio', name_en: 'Exercise' },
  { id: 'Brain', name_es: 'Cerebro', name_en: 'Brain' },
  { id: 'Laptop', name_es: 'Laptop', name_en: 'Laptop' },
  { id: 'CandlestickChart', name_es: 'Trading', name_en: 'Trading' },
  { id: 'TrendingUp', name_es: 'Tendencia', name_en: 'Trending' },
  { id: 'Building2', name_es: 'Edificio', name_en: 'Building' },
  { id: 'BookOpen', name_es: 'Libro', name_en: 'Book' },
  { id: 'Heart', name_es: 'Corazón', name_en: 'Heart' },
  { id: 'Star', name_es: 'Estrella', name_en: 'Star' },
  { id: 'Target', name_es: 'Objetivo', name_en: 'Target' },
  { id: 'Zap', name_es: 'Energía', name_en: 'Energy' },
  { id: 'Coffee', name_es: 'Café', name_en: 'Coffee' },
  { id: 'Music', name_es: 'Música', name_en: 'Music' },
  { id: 'Palette', name_es: 'Arte', name_en: 'Art' },
  { id: 'Briefcase', name_es: 'Trabajo', name_en: 'Work' },
  { id: 'GraduationCap', name_es: 'Educación', name_en: 'Education' },
  { id: 'Users', name_es: 'Social', name_en: 'Social' },
  { id: 'Home', name_es: 'Hogar', name_en: 'Home' },
  { id: 'Car', name_es: 'Vehículo', name_en: 'Vehicle' },
  { id: 'Plane', name_es: 'Viaje', name_en: 'Travel' },
  
  // Nuevos iconos solicitados
  { id: 'Sparkles', name_es: 'Meditación', name_en: 'Meditation' },
  { id: 'Activity', name_es: 'Salud', name_en: 'Health' },
  { id: 'Moon', name_es: 'Sueño', name_en: 'Sleep' },
  { id: 'Apple', name_es: 'Nutrición', name_en: 'Nutrition' },
  { id: 'Shield', name_es: 'Disciplina', name_en: 'Discipline' },
  { id: 'Clock', name_es: 'Productividad', name_en: 'Productivity' },
  { id: 'BookMarked', name_es: 'Lectura', name_en: 'Reading' },
  { id: 'Lightbulb', name_es: 'Aprendizaje', name_en: 'Learning' },
  { id: 'PenTool', name_es: 'Creatividad', name_en: 'Creativity' },
  { id: 'PencilLine', name_es: 'Escritura', name_en: 'Writing' },
  { id: 'TreeDeciduous', name_es: 'Naturaleza', name_en: 'Nature' },
  { id: 'UsersRound', name_es: 'Familia', name_en: 'Family' },
  { id: 'UserPlus', name_es: 'Amigos', name_en: 'Friends' },
  { id: 'Flame', name_es: 'Espiritualidad', name_en: 'Spirituality' },
  { id: 'ListChecks', name_es: 'Hábitos', name_en: 'Habits' },
  { id: 'CalendarDays', name_es: 'Planificación', name_en: 'Planning' },
  { id: 'RotateCw', name_es: 'Rutina', name_en: 'Routine' },
  { id: 'Rocket', name_es: 'Motivación', name_en: 'Motivation' },
  { id: 'MessageCircle', name_es: 'Reflexión', name_en: 'Reflection' },
  { id: 'Scale', name_es: 'Balance', name_en: 'Balance' },
  
  // Icono genérico
  { id: 'Circle', name_es: 'Otro', name_en: 'Other' },
]

// ==========================================
// FINANZAS (Finance) ICONS
// ==========================================
export const FINANCE_ICON_OPTIONS = [
  // Original icons (mantener compatibilidad)
  { id: 'Home', name_es: 'Casa', name_en: 'Home' },
  { id: 'Utensils', name_es: 'Comida', name_en: 'Food' },
  { id: 'Car', name_es: 'Auto', name_en: 'Car' },
  { id: 'Heart', name_es: 'Salud', name_en: 'Health' },
  { id: 'GraduationCap', name_es: 'Educación', name_en: 'Education' },
  { id: 'Gamepad2', name_es: 'Entretenimiento', name_en: 'Entertainment' },
  { id: 'CreditCard', name_es: 'Tarjeta', name_en: 'Credit Card' },
  { id: 'Shirt', name_es: 'Ropa', name_en: 'Clothing' },
  { id: 'BadgeDollarSign', name_es: 'Salario', name_en: 'Salary' },
  { id: 'TrendingUp', name_es: 'Inversiones', name_en: 'Investments' },
  { id: 'PiggyBank', name_es: 'Ahorros', name_en: 'Savings' },
  { id: 'Gift', name_es: 'Regalos', name_en: 'Gifts' },
  { id: 'Briefcase', name_es: 'Negocio', name_en: 'Business' },
  { id: 'Building2', name_es: 'Inmuebles', name_en: 'Real Estate' },
  { id: 'Zap', name_es: 'Servicios', name_en: 'Utilities' },
  
  // Nuevos iconos solicitados
  { id: 'ShoppingCart', name_es: 'Supermercado', name_en: 'Groceries' },
  { id: 'UtensilsCrossed', name_es: 'Restaurantes', name_en: 'Restaurants' },
  { id: 'Bus', name_es: 'Transporte', name_en: 'Transport' },
  { id: 'Fuel', name_es: 'Gasolina', name_en: 'Fuel' },
  { id: 'ShieldCheck', name_es: 'Seguro', name_en: 'Insurance' },
  { id: 'RefreshCw', name_es: 'Suscripciones', name_en: 'Subscriptions' },
  { id: 'Wifi', name_es: 'Internet', name_en: 'Internet' },
  { id: 'Smartphone', name_es: 'Teléfono Celular', name_en: 'Cell Phone' },
  { id: 'Plane', name_es: 'Viajes', name_en: 'Travel' },
  { id: 'Palmtree', name_es: 'Vacaciones', name_en: 'Vacation' },
  { id: 'FileText', name_es: 'Impuestos', name_en: 'Taxes' },
  { id: 'CircleDollarSign', name_es: 'Deudas', name_en: 'Debt' },
  { id: 'Landmark', name_es: 'Hipoteca', name_en: 'Mortgage' },
  { id: 'HeartHandshake', name_es: 'Donaciones', name_en: 'Donations' },
  { id: 'PawPrint', name_es: 'Mascotas', name_en: 'Pets' },
  { id: 'Baby', name_es: 'Hijos', name_en: 'Children' },
  { id: 'Laptop', name_es: 'Tecnología', name_en: 'Technology' },
  { id: 'Wrench', name_es: 'Mantenimiento', name_en: 'Maintenance' },
  { id: 'AlertTriangle', name_es: 'Emergencias', name_en: 'Emergencies' },
  { id: 'Coffee', name_es: 'Cafetería', name_en: 'Coffee Shop' },
  { id: 'Beer', name_es: 'Bebidas', name_en: 'Drinks' },
  { id: 'Dumbbell', name_es: 'Gimnasio', name_en: 'Gym' },
  { id: 'Pill', name_es: 'Farmacia', name_en: 'Pharmacy' },
  { id: 'Scissors', name_es: 'Belleza', name_en: 'Beauty' },
  { id: 'Music', name_es: 'Música', name_en: 'Music' },
  { id: 'Tv', name_es: 'Streaming', name_en: 'Streaming' },
  
  // Servicios del hogar
  { id: 'Lightbulb', name_es: 'Luz / Electricidad', name_en: 'Electricity' },
  { id: 'Droplets', name_es: 'Agua', name_en: 'Water' },
  { id: 'Flame', name_es: 'Gas', name_en: 'Gas' },
  { id: 'Phone', name_es: 'Telefonía Fija', name_en: 'Landline' },
  
  // Icono genérico
  { id: 'Circle', name_es: 'Otro', name_en: 'Other' },
]

// ==========================================
// IDEAS (Idea Buckets) ICONS
// ==========================================
export const IDEA_ICON_OPTIONS = [
  // Original icons (mantener compatibilidad)
  { id: 'Sparkles', name_es: 'Brillante', name_en: 'Sparkles' },
  { id: 'Rocket', name_es: 'Startup', name_en: 'Startup' },
  { id: 'Building2', name_es: 'Empresa', name_en: 'Company' },
  { id: 'User', name_es: 'Personal', name_en: 'Personal' },
  { id: 'Lightbulb', name_es: 'Ideas', name_en: 'Ideas' },
  { id: 'Briefcase', name_es: 'Negocios', name_en: 'Business' },
  { id: 'Brain', name_es: 'Cerebro', name_en: 'Brain' },
  { id: 'Laptop', name_es: 'Tech', name_en: 'Tech' },
  { id: 'Star', name_es: 'Favoritos', name_en: 'Favorites' },
  { id: 'Heart', name_es: 'Pasión', name_en: 'Passion' },
  { id: 'MoreHorizontal', name_es: 'Otros', name_en: 'Other' },
  
  // Nuevos iconos solicitados
  { id: 'FolderKanban', name_es: 'Proyecto', name_en: 'Project' },
  { id: 'Package', name_es: 'Producto', name_en: 'Product' },
  { id: 'Smartphone', name_es: 'App', name_en: 'App' },
  { id: 'Wand2', name_es: 'Innovación', name_en: 'Innovation' },
  { id: 'Search', name_es: 'Investigación', name_en: 'Research' },
  { id: 'FileText', name_es: 'Contenido', name_en: 'Content' },
  { id: 'Megaphone', name_es: 'Marketing', name_en: 'Marketing' },
  { id: 'BadgeCheck', name_es: 'Marca', name_en: 'Brand' },
  { id: 'Palette', name_es: 'Diseño', name_en: 'Design' },
  { id: 'Target', name_es: 'Estrategia', name_en: 'Strategy' },
  { id: 'Cog', name_es: 'Automatización', name_en: 'Automation' },
  { id: 'Bot', name_es: 'IA', name_en: 'AI' },
  { id: 'FlaskConical', name_es: 'Experimento', name_en: 'Experiment' },
  { id: 'Network', name_es: 'Sistema', name_en: 'System' },
  { id: 'Wrench', name_es: 'Herramientas', name_en: 'Tools' },
  { id: 'GraduationCap', name_es: 'Educación', name_en: 'Education' },
  { id: 'BookOpen', name_es: 'Aprendizaje', name_en: 'Learning' },
  { id: 'PenTool', name_es: 'Creatividad', name_en: 'Creativity' },
  { id: 'Eye', name_es: 'Visión', name_en: 'Vision' },
  { id: 'Zap', name_es: 'Energía', name_en: 'Energy' },
  { id: 'Trophy', name_es: 'Logros', name_en: 'Achievements' },
  { id: 'Compass', name_es: 'Exploración', name_en: 'Exploration' },
  { id: 'Map', name_es: 'Roadmap', name_en: 'Roadmap' },
  { id: 'GitBranch', name_es: 'Desarrollo', name_en: 'Development' },
  { id: 'Blocks', name_es: 'Componentes', name_en: 'Components' },
  
  // Icono genérico
  { id: 'Circle', name_es: 'Otro', name_en: 'Other' },
]

/**
 * Helper function to get the icon label based on locale
 * @param {Object} icon - Icon object with name_es and name_en
 * @param {string} locale - Current locale ('es-MX' or 'en-US')
 * @returns {string} - Localized icon name
 */
export const getIconLabel = (icon, locale) => {
  if (!icon) return ''
  // Support both new format (name_es/name_en) and legacy format (name)
  if (icon.name_es && icon.name_en) {
    return locale === 'es-MX' ? icon.name_es : icon.name_en
  }
  return icon.name || icon.id
}

/**
 * Find an icon by ID from an icon options array
 * @param {Array} iconOptions - Array of icon options
 * @param {string} iconId - Icon ID to find
 * @returns {Object|undefined} - Found icon object or undefined
 */
export const findIconById = (iconOptions, iconId) => {
  return iconOptions.find(icon => icon.id === iconId)
}
